import { render, staticRenderFns } from "./VideoUrlSetter.vue?vue&type=template&id=1dfd0b7f&"
import script from "./VideoUrlSetter.vue?vue&type=script&lang=js&"
export * from "./VideoUrlSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VideoUrlSetter.vue"
export default component.exports